module.exports = __webpack_public_path__ + "static/Escalera-4eb749d7c186e864c4d8f4ef9347f9ae.jpg";